/* ChipCloseButton CSS Module */

.closeButton {
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: var(--spaces-24);
  justify-content: center;
  margin-left: calc(-1 * var(--spaces-4));
  outline: none;
  position: relative;
  width: var(--spaces-24);
}

/* Focus ring using react-aria data attribute */
.closeButton[data-focus-visible]::after {
  border-radius: 50%;
  box-shadow: inset 0 0 0 2px var(--colors-border-interactive-focused);
  content: '';
  inset: 2px;
  position: absolute;
}

